import { FC } from 'react'
import { Link } from 'react-router-dom'
import { Box, Stack, Typography } from '@mui/material'
import { TRowOfPaidServicesForKanban } from '../../../Api/PaidService/types'

type KanbanCardProps = {
  item: TRowOfPaidServicesForKanban
}

export const KanbanCard: FC<KanbanCardProps> = ({ item }) => {
  return (
    <Stack sx={{ minHeight: '100px', position: 'relative' }}>
      <Link
        style={{ textDecoration: 'none', fontSize: '12px' }}
        to={`/service-page/${item?.id}`}
      >
        {item.documentInfo}
      </Link>
      <Typography sx={{ fontSize: '14px' }}>{item.clientNames?.[0]}</Typography>
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ position: 'absolute', bottom: '-18px' }}
      >
        {item?.responsibleUserNames?.[0]}
      </Typography>
    </Stack>
  )
}
